<notify-popup
  *ngIf="showLangNotify"
  [okLabel]="null"
  [cancelLabel]="'Ok'"
  (onChanged)="hideNotify()"
  [msg]="'ASelect.UseEnglishInput' | translate">
</notify-popup>

<div class="a-select-company"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.has-select]="searchValue">

  <div class="a-select-company__optional" *ngIf="isOptional">{{ 'ASelect.Optional' | translate }}</div>

  <div class="a-select-company__inner" 
    [class.is-disabled]="isDisabled"
    [class.has-value]="control.get('name').value"
    [class.has-error]="control.invalid && isSubmitted">
    
    <div class="a-select-company__items-bg" *ngIf="showItems" (click)="showDropdown(false)"></div>
    <div class="a-select-company__items" @slideInOut *ngIf="showItems"
      [class.open-top]="openPositionTop">
      <div class="a-select-company__items-inner is-scroll" #scrolledEl>
        <div class="a-select-company__item"
          *ngFor="let item of searchVariants; let i = index;" 
          [id]="'a-select-item-id-' + i"
          [class.active]="selectedItem ? item.name === selectedItem.name && item.location.country === selectedItem.location.country : null"
          (click)="selectItem(item);">
          <div class="is-logo" [avatarImage]="item.logo"></div>
          <div>
            {{ item.name }}<br>
            <span>{{ item.location.country }}</span>
          </div>
        </div>
      </div>
      <div class="a-select-company__line-loader" @opacityInOut
        *ngIf="loadingResults && searchVariants && searchVariants.length !== 0 
          && (searchInput$ | async) && (searchInput$ | async) !== ''">
      </div>
      <div class="a-select-company__nothing" 
        *ngIf="loadingResults && searchVariants && searchVariants.length === 0 
          && (searchInput$ | async) && (searchInput$ | async) !== ''">
        {{ 'ASelect.Loading' | translate }}
      </div>
      <div class="a-select-company__nothing" 
        *ngIf="!loadingResults && searchVariants && searchVariants.length === 0 
          && (searchInput$ | async) && (searchInput$ | async).length > 2">
        <b>{{ 'ASelect.CreateOwnCompany' | translate }}</b>
      </div>
      <div class="a-select-company__nothing" 
        *ngIf="!loadingResults && searchVariants && searchVariants.length === 0 
          && (!(searchInput$ | async) || (searchInput$ | async) === '')">
        {{ 'ASelect.StartTyping' | translate }}
      </div>
      <div class="a-select-company__nothing" 
        *ngIf="!loadingResults && searchVariants && searchVariants.length === 0 
          && (searchInput$ | async) && (searchInput$ | async) !== '' && (searchInput$ | async).length <= 2">
        {{ 'ASelect.ContinueTyping' | translate }}
      </div>
    </div>

    <div class="a-select-company__input-box">
      <input #selectEl
        placeholder=" "
        type="text"
        [ngModel]="searchValue"
        (input)="inputValidator($event)"
        (focus)="onFocus()" 
        (blur)="onBlurAction()">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown(showItems ? false : true); showItems && selectEl.focus();">
      </i>
    </div>
  </div>
</div>